'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* Company facts from the HubSpot record; the outbound WhatsApp workstream is from the 'rewaa-outbound' Linear project, which was in Backlog at the last sweep — solution_p2 describes it as in progress, not shipped. CONFIRM BEFORE SHIPPING: whether inbound support is live, and what escalates.
 *
 * No stats row and no results table: no cleared figure exists for Rewaa.
 * Add the stats, the table and the six-place number check from the
 * customer-stories skill in the same commit that lands real numbers. */
const RewaaCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Rewaa"
        title={t.customerStories['rewaa_hero_title']}
        subtitle={t.customerStories['rewaa_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-rewaa.svg',
          logoAlt: 'Rewaa',
          customerName: 'Rewaa',
          company: t.customerStories['rewaa_company_description'],
          industry: t.customerStories['rewaa_industry'],
          websiteUrl: 'https://www.rewaa.com',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['rewaa_location'],
            },
          ],
          keyResults: [
            t.customerStories['rewaa_key_result_1'],
            t.customerStories['rewaa_key_result_2'],
            t.customerStories['rewaa_key_result_3'],
            t.customerStories['rewaa_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['rewaa_intro']}</p>

        <h2>{t.customerStories['rewaa_challenge_title']}</h2>
        <p>{t.customerStories['rewaa_challenge_p1']}</p>
        <p>{t.customerStories['rewaa_challenge_p2']}</p>
        <p>{t.customerStories['rewaa_challenge_p3']}</p>

        <h2>{t.customerStories['rewaa_solution_title']}</h2>
        <p>{t.customerStories['rewaa_solution_p1']}</p>
        <p>{t.customerStories['rewaa_solution_p2']}</p>
        <p>{t.customerStories['rewaa_solution_p3']}</p>

        <h2>{t.customerStories['rewaa_impact_title']}</h2>
        <p>{t.customerStories['rewaa_impact_p1']}</p>
        <p>{t.customerStories['rewaa_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default RewaaCaseStudy;
